import fetch from "../fetch";

export default ({ data, isNew }) =>
  fetch({
    path: `/em/entities${isNew ? "" : `/${data.entity_id}`}`,
    method: isNew ? "POST" : "PUT",
    data
  });
